const common = {
  black: '#000000',
  white: '#ffffff',
};

export default common;
